module.exports = require("immutability-helper");


//////////////////
// WEBPACK FOOTER
// external "immutability-helper"
// module id = 588
// module chunks = 0